<div class="pb-8 pb-lg-10" dir="rtl">
  <h2 class="fw-bolder text-dark">تم أستكمال الحجز بنجاح</h2>
</div>
<div class="mb-10 row" dir="rtl">
  <div class="col-md-6 col-sm-12 mb-2" dir="rtl">
    <div class="border-t border-gray-200 px-4 py-5 sm:px-6" dir="rtl">
      <div class="stepper-label mx-4  mb-4">
        <h5 class="stepper-desc fw-semibold text-muted">
          أسم العميل
        </h5>
        <h3 class="stepper-title">



          أسماء محمد الهنائي
        </h3>
      </div>
      <div class="stepper-label mx-4  mb-4">
        <h5 class="stepper-desc fw-semibold text-muted">
          رقم الهاتف
        </h5>
        <h3 class="stepper-title">
          96919868
        </h3>
      </div>
      <div class="stepper-label mx-4  mb-4">
        <h5 class="stepper-desc fw-semibold text-muted">
          البريد الالكتروني
        </h5>
        <h3 class="stepper-title">
          khalfan.alamri20@gmail.com
        </h3>
      </div>
    </div>
  </div>
  <div class="col-md-6 col-sm-12 mb-2" dir="rtl">
    <div class="border-t border-gray-200 px-4 py-5 sm:px-6" dir="rtl">
      <div class="stepper-label mx-4  mb-4">
        <h5 class="stepper-desc fw-semibold text-muted">
          تاريخ الحجز
        </h5>
        <h3 class="stepper-title">
          12/09/2022
        </h3>
      </div>
      <div class="stepper-label mx-4  mb-4">
        <h5 class="stepper-desc fw-semibold text-muted">
          وقت الحجز
        </h5>
        <h3 class="stepper-title">
          12:00 - 1:00
        </h3>
      </div>
      <div class="stepper-label mx-4  mb-4">
        <h5 class="stepper-desc fw-semibold text-muted">
          الملعب
        </h5>
        <h3 class="stepper-title">
          الملعب الاول
        </h3>
      </div>
      <div class="stepper-label mx-4  mb-4">
        <h5 class="stepper-desc fw-semibold text-muted">
          طريقة الدفع
        </h5>
        <h3 class="stepper-title">
          عند الوصول
        </h3>
      </div>
    </div>
  </div>
</div>
